<section id="wrapper" class="container content-wrapper">
  <article class="ueber_mich">
    <div class="row">
      <div class="col-xs-12 col-md-6">
      <p>Quality works!</p>
      </div>
    </div>
  </article>
</section>













